/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * The House Data
 */

import room2ThemeImg from '../assets/img/offers/room-2-theme.jpg'
import room2ThemeWebp from '../assets/img/offers/room-2-theme.webp'
import room3ThemeImg from '../assets/img/offers/room-3-theme.jpg'
import room3ThemeWebp from '../assets/img/offers/room-3-theme.webp'
import suiteMontanhaImg from '../assets/img/offers/suite-montanha.jpg'
import suiteMontanhaWebp from '../assets/img/offers/suite-montanha.webp'
import poolImg from '../assets/img/offers/pool.jpg'
import poolWebp from '../assets/img/offers/pool.webp'
import diningRoomImg from '../assets/img/offers/dining-room.jpg'
import diningRoomWebp from '../assets/img/offers/dining-room.webp'
import livingRoomImg from '../assets/img/offers/living-room.jpg'
import livingRoomWebp from '../assets/img/offers/living-room.webp'

export const THEHOUSE = {
    text: (<>Situada na emblemática Vila do Caramulo, outrora conhecida como a Pensão Moderna, albergou turistas e familiares de doentes internados nos sanatórios durante a época da Estancia. Foi adquirida nos anos 90 pelo pai dos sócios da Beecaramulo e recentemente, restaurada e ampliada para converter no primeiro alojamento nacional temático dedicado à Apicultura.<br/>De traça neoclássica, e com uma decoração exclusiva, cada detalhe foi pensado para proporcionar uma estadia inesquecível.</>),
    cards: [
        {
            id: 0,
            title: '3 Quartos Duplos Temáticos',
            text: 'Três quartos duplos temáticos com possibilidade de cama extra.',
            src: room2ThemeImg,
            srcWebp: room2ThemeWebp,
        },
        {
            id: 1,
            title: '1 Quarto Triplo Temático',
            text: 'Quarto de dimensões generosas com sofá-cama.',
            src: room3ThemeImg,
            srcWebp: room3ThemeWebp,
        },
        {
            id: 2,
            title: '2 Suites Montanha',
            text: 'Duas suites com varanda privativa e vista para a montanha.',
            src: suiteMontanhaImg,
            srcWebp: suiteMontanhaWebp,
        },
        {
            id: 3,
            title: 'Piscina',
            text: 'Piscina exterior com jardim.',
            src: poolImg,
            srcWebp: poolWebp,
        },
        {
            id: 4,
            title: 'Sala de Refeições',
            text: 'Sala de refeições com espaço para show cooking.',
            src: diningRoomImg,
            srcWebp: diningRoomWebp,
        },
        {
            id: 5,
            title: 'Sala de Estar',
            text: 'Sala de estar com lareira aconchegante.',
            src: livingRoomImg,
            srcWebp: livingRoomWebp,
        },
    ]
}